import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient()

const prefetchQuery = (key, data) => {
  queryClient.setQueryData([key], data)
}

export { queryClient, prefetchQuery }
